import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'Organization' | 'WebPage' | 'FAQPage' | 'Service';
  data: Record<string, any>;
}

export function useSchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = `schema-${type.toLowerCase()}`;
    
    let schemaData: Record<string, any> = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data
    };

    script.textContent = JSON.stringify(schemaData);
    
    // Remove existing schema of same type
    const existing = document.getElementById(`schema-${type.toLowerCase()}`);
    if (existing) {
      existing.remove();
    }
    
    document.head.appendChild(script);

    return () => {
      const scriptToRemove = document.getElementById(`schema-${type.toLowerCase()}`);
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, [type, data]);
}

export function getBaseUrl(): string {
  return import.meta.env.VITE_SITE_URL || 'https://eastafricaeqc.com';
}
